<template> 
   <v-card
    class="mx-auto"
    elevation="16"
    max-width="100hv"
  >
    <v-card-item>
      <v-card-title>
        Inicio
      </v-card-title>

      <v-card-subtitle>
        Card subtitle secondary text
      </v-card-subtitle>
    </v-card-item>

    <v-card-text>
      

    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent ({
    name: 'HomeStart',
    setup() {
        return {
        }
    }
    })
</script>
